<template>
  <div class="">
    <h2>Quick-links</h2>

    <DivLinkButton
      class=""
      route-name="Joining"
    >
      <h4 class="heading">Joining</h4>
      <p class="text-align-justify">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
        incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris
        nisi ut aliquip ex ea commodo consequat.
      </p>
    </DivLinkButton>

    <DivLinkButton
      class=""
      route-name="Comms"
    >
      <h4 class="heading">Communications</h4>
      <p class="text-align-justify">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
        incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris
        nisi ut aliquip ex ea commodo consequat.
      </p>
    </DivLinkButton>

  </div>
</template>

<script>
import DivLinkButton from './basic_comp/DivLinkButton'
  ''
export default {
  name: "QuickLinks",
  components: {
    DivLinkButton
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/QuickLinks.vue